import translator from '@/locales';

import BidPauseStatusColumn from './columns/BidPauseStatusColumn';
import BidStatusColumn from './columns/BidStatusColumn';
import BidCostColumn from './columns/BidCostColumn';
import BidPriceOfferColumn from './columns/BidPriceOfferColumn';
import BidWinRateColumn from './columns/BidWinRateColumn';
import AverageInstallCostColumn from '@@/advertisement/common/keyword/columns/AverageInstallCostColumn';
import ConversionRateColumn from '@@/advertisement/common/keyword/columns/ConversionRateColumn';
import ImpressionColumn from '@@/advertisement/common/keyword/columns/ImpressionColumn';
import InstallColumn from '@@/advertisement/common/keyword/columns/InstallColumn';
import MatchTypeColumn from '@@/advertisement/common/keyword/columns/MatchTypeColumn';
import QueryColumn from '@@/advertisement/common/keyword/columns/QueryColumn';

import { sum } from '@/utils/arrayAggregation';
import conversionRate from '@/utils/conversionRate';

const IMPRESSIONS_COUNT_PROPERTY = 'impressionCount';
const INSTALL_COUNT_PROPERTY = 'installCount';

export const SEARCH_ADS_GAME_CPI_LIMIT = 7500;
export const SEARCH_ADS_APP_CPI_LIMIT = 20000;
export const IS_SEARCH_ADS_CPI_LIMIT_ENABLED = true;

export const columns = metadata => {
  const columns = {
    hideFromSetting: [
      {
        label: '',
        property: 'paused',
        component: BidPauseStatusColumn,
        fixed: true,
      },
    ],
    static: [
      {
        label: translator.t('ADVERTISEMENT.BID.KEYWORD'),
        property: 'query',
        component: QueryColumn,
        fixed: true,
        summaryBehaviour: () => translator.t('SUM'),
      },
      {
        label: translator.t('ADVERTISEMENT.BID.MAX_CPI'),
        property: 'priceOffer',
        component: BidPriceOfferColumn,
        fixed: false,
      },
      {
        label: translator.t('ADVERTISEMENT.BID.MATCH_TYPE'),
        property: 'matchingType',
        component: MatchTypeColumn,
        fixed: false,
      },
    ],
    dynamic: [
      {
        label: translator.t('ADVERTISEMENT.BID.COLUMN_AVG_CPI'),
        property: 'avgInstallCost',
        component: AverageInstallCostColumn,
        isHiddenDefault: false,
        width: 180,
      },
      {
        label: translator.t('ADVERTISEMENT.BID.COLUMN_CONV_RATE'),
        property: 'conversionRate',
        component: ConversionRateColumn,
        isHiddenDefault: false,
        summaryBehaviour: (_, allColumnsData) => {
          const impressionCounts = allColumnsData.map(
            val => val[IMPRESSIONS_COUNT_PROPERTY],
          );
          const installCounts = allColumnsData.map(
            val => val[INSTALL_COUNT_PROPERTY],
          );
          return (
            '%' + conversionRate(sum(installCounts), sum(impressionCounts))
          );
        },
      },
      {
        label: translator.t('ADVERTISEMENT.BID.COLUMN_COST'),
        property: 'totalInstallCost',
        component: BidCostColumn,
        isHiddenDefault: false,
        summaryBehaviour: sum,
      },
      {
        label: translator.t('ADVERTISEMENT.BID.COLUMN_IMPRESSIONS'),
        property: IMPRESSIONS_COUNT_PROPERTY,
        component: ImpressionColumn,
        isHiddenDefault: false,
        summaryBehaviour: sum,
      },
      {
        label: translator.t('ADVERTISEMENT.BID.COLUMN_INSTALLATION'),
        property: INSTALL_COUNT_PROPERTY,
        component: InstallColumn,
        isHiddenDefault: false,
        summaryBehaviour: sum,
        width: 180,
      },
      {
        label: translator.t('ADVERTISEMENT.BID.COLUMN_STATUS'),
        property: 'status',
        component: BidStatusColumn,
        isHiddenDefault: false,
      },
      {
        label: translator.t('ADVERTISEMENT.BID.COLUMN_WIN_RATE'),
        property: 'winRate',
        component: BidWinRateColumn,
        isHiddenDefault: false,
      },
    ],
  };

  columns.dynamic = columns.dynamic.filter(({ shouldShow }) =>
    shouldShow ? shouldShow(metadata) : true,
  );

  return columns;
};
